class ModalDiscountCode extends HTMLElement {
	constructor() {
		super();

		this.showTimerDelay = this.dataset.timerDelay;

		this.closeButton = this.querySelectorAll(
			'[data-discount-code-modal-close]'
		);

		for (let btn of this.closeButton) {
			btn.addEventListener('click', () => {
				this.close(true);
			});
		}
	}

	open() {
		this.classList.add('open');
	}

	close() {
		if (!this.classList.contains('open')) {
			return;
		}

		this.classList.remove('open');
	}
}

customElements.define('modal-discount-code', ModalDiscountCode);
